var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"mx-auto capa",attrs:{"src":'data:image/jpeg;base64,' + _vm.base64Content}})
}
var staticRenderFns = []

export { render, staticRenderFns }